import {exeRequest} from '../utils/APIUtils'

export default {
    getAll : async  () => exeRequest(`/clients`, "GET"),
    upsert : async  (client) => exeRequest(`/clients`, "PUT", client),
    get : async  (id) => exeRequest(`/clients/${id}`, "GET"),
    resetPassword : async  (id) => exeRequest(`/clients/${id}/reset-password`, "GET"),
    lockUnlock : async  (id, value) => exeRequest(`/clients/${id}/lock-unlock/${value}`, "GET"),
    uploadClient: async (data)=> exeRequest(`/clients/import`, "POST", data, null, true)
}